/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedRentRequestDto } from '../../models/backend-patched-rent-request-dto';
import { BackendRentDto } from '../../models/backend-rent-dto';

export interface OpexesRentPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedRentRequestDto;
}

export function opexesRentPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: OpexesRentPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRentDto>> {
  const rb = new RequestBuilder(rootUrl, opexesRentPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRentDto>;
    }),
  );
}

opexesRentPartialUpdate$XWwwFormUrlencoded.PATH = '/api/opexes/rent/{id}/';
